import { bl_inv_mst_category_level_setting_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryMstCategoryLevelSettingsModel extends BaseContainerModel {
    bl_inv_mst_category_level_setting_hdr: bl_inv_mst_category_level_setting_hdr_RowClass = new bl_inv_mst_category_level_setting_hdr_RowClass();
}
